import { createRouter, createWebHistory } from 'vue-router'
import LandingView from '@/views/LandingView.vue'
import ThankYouView from '@/views/ThankYouView.vue'
import ErrorView from '@/views/ErrorView.vue'
import { useSubscriptionStore } from '@/stores/subscriptionStore'

// The confirmation only follows a subscribe (or an already-active number) in this visit. A copied
// or bookmarked /thank-you link goes back to the landing page with its query (brand, variant, mode).
function requireSubscription(to) {
  const store = useSubscriptionStore()
  if (store.result || store.alreadySubscribed) return true
  return { name: 'landing', query: to.query, replace: true }
}

const routes = [
  { path: '/', name: 'landing', component: LandingView },
  { path: '/thank-you', name: 'thank-you', component: ThankYouView, beforeEnter: requireSubscription },
  { path: '/error', name: 'error', component: ErrorView },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
